import React, { type ReactElement } from 'react';
import { faPersonWalkingArrowLoopLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'reactstrap';
import TooltipItem from 'atom-components/tooltip-item';
import { pluralise } from 'helpers/string.helpers';

type Props = {
  onClick: () => void;
  contributingMarksCount: number;
  finishedMarksCount: number;
};

export default function ForceReallocateResponseButton({
  onClick,
  contributingMarksCount,
  finishedMarksCount
}: Props): ReactElement {
  const someMarksAreFinished = finishedMarksCount > 0;

  const button = (
    <Button type="button" color="primary" onClick={onClick} disabled={someMarksAreFinished}>
      <FontAwesomeIcon icon={faPersonWalkingArrowLoopLeft} />{' '}
      {contributingMarksCount > 0 ? 'Force' : ''} Reallocate Response
    </Button>
  );

  return someMarksAreFinished ? (
    <TooltipItem
      tooltip={`Cannot Force Reallocate Response because ${finishedMarksCount === 1 ? 'a' : 'some'}
        ${pluralise('mark', finishedMarksCount)} ${pluralise('is', finishedMarksCount)} finished.`}
    >
      {button}
    </TooltipItem>
  ) : (
    button
  );
}
